/**
 * Learner profile page.
 */
import React, { useState } from "react";
import { Box, Tab, Tabs, Divider } from "@mui/material";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { useTranslation } from "react-i18next";

import { VAvatar, VButton, VText } from "form";
import { BThumb } from "components";
import ProfileContent from "./profile.content";
import ProfileDetail from "./profile.detail";
import ProfileGroup from "./profile.group";
import { useAsterController } from "context";
import { getUserName } from "utils/string";

/**
 * Tabbed profile with details, groups, and course progress.
 */
const Profile = () => {
  const { t } = useTranslation("common");

  const [controller] = useAsterController();
  const { user, loadedDashboard } = controller;

  const [tab, setTab] = useState(0);
  const handleSetTabValue = (_, newValue) => setTab(newValue);

  return (
    <Box className="m-0 md:m-6 v-bg-body rounded-none md:rounded-md flex-1">
      <Box className="mx-auto">
        <Box className="p-4 md:p-8">
          <BThumb src={user.cover ? user.cover : `${process.env.REACT_APP_S3_ASSET_ENDPOINT}/v2-assets/admin/default-cover-2.svg`} error="" eager className="w-full h-64 rounded-md" />
          <Box className={`relative flex w-full md:justify-start flex-wrap items-end -mt-24 pl-0 md:pl-4 ${tab === 0 ? "justify-between" : "justify-start"}`}>
            <VAvatar src={user.avatar} className="w-40 h-40" />
            {loadedDashboard ? (
              <VText className="text-3xl md:text-4xl my-1" div>
                {getUserName(user)}
              </VText>
            ) : (
              <Skeleton className="w-40 h-10" />
            )}
            <Link className="no-underline ml-auto" to="/settings">
              <VButton variant="text" color="secondary" className="h-min text-sm normal-case no-underline my-1">
                {t("Edit")}
              </VButton>
            </Link>
          </Box>
        </Box>
        <Box className="h-8">
          <Tabs orientation="horizontal" value={tab} onChange={handleSetTabValue} className="h-9 px-8 min-h-min">
            <Tab label={t("About Me")} className="min-h-0 text-dark dark:text-white normal-case" />
            <Tab label={t("My Content")} className="min-h-0 text-dark dark:text-white normal-case" />
            <Tab label={t("Group")} className="min-h-0 text-dark dark:text-white normal-case" />
          </Tabs>
          <Divider className="bg-gray-200 dark:bg-gray-500" />
        </Box>
        {tab === 0 && <ProfileDetail />}
        {tab === 1 && <ProfileContent />}
        {tab === 2 && <ProfileGroup />}
      </Box>
    </Box>
  );
};

export default Profile;
